import { render, staticRenderFns } from "./wish_list.vue?vue&type=template&id=3c697fe4&"
import script from "./wish_list.vue?vue&type=script&lang=js&"
export * from "./wish_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports